<template>
  <vue-element-loading
    :active="onLoading"
    spinner="spinner"
    color="rgba(0, 0, 0, .7)"
    background-color="rgba(255, 255, 255, .9)"
    text="กรุณารอสักครู่.."
    is-full-screen
  />

  <div class="row d-flex justify-content-center">
    <div class="col-md-12 mr-auto ml-auto">
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <div class="card-header">
              <h4 class="card-title text-center">เข้าสู่ระบบ</h4>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="card-body">
            <div class="row">
              <div
                class="
                  col-xxxl-4
                  col-xxl-4
                  col-xl-4
                  col-lg-6
                  col-md-6
                  col-sm-6
                  col-xs-8
                  mr-auto
                  ml-auto
                "
              >
                <div class="row">
                  <div
                    class="col-md-12 text-center"
                    style="margin: 0 10px 0 10px"
                  >
                    <div>
                      <n-button
                        class="btn-line"
                        size="lg"
                        style="width: 100%"
                        :disabled="logingin"
                        @click="loginWithLine"
                      >
                        <em class="fab fa-line fa-lg"></em> ล็อกอินด้วย Line
                      </n-button>
                    </div>
                    <div>
                      <n-button
                        class="btn-facebook"
                        size="lg"
                        style="width: 100%"
                        :disabled="logingin"
                        @click="loginWithFacebook"
                      >
                        <em class="fab fa-facebook fa-lg"></em> ล็อกอินด้วย
                        Facebook
                      </n-button>
                    </div>

                    <div>
                      <n-button
                        class="btn-google"
                        size="lg"
                        style="width: 100%"
                        :disabled="logingin"
                        @click="loginWithGoogle"
                      >
                        <em class="fab fa-google fa-lg"></em> ล็อกอินด้วย Google
                      </n-button>
                    </div>
                  </div>
                  <div class="col-md-12" style="margin: 0 10px 0 10px">
                    <a href="#" @click="onClickShowLogin" class="text-left"
                      >เป็นสมาชิกอยู่แล้ว?</a
                    >
                    <a
                      href="/registration"
                      class="text-right"
                      style="float: right"
                      >สมัครสมาชิก</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card" v-if="showLogin">
        <div class="card-body">
          <div class="row">
            <div
              class="
                col-xxxl-4
                col-xxl-4
                col-xl-4
                col-lg-6
                col-md-6
                col-sm-6
                col-xs-8
                mr-auto
                ml-auto
              "
            >
              <form method="#" action="#" v-on:submit.prevent="onLogin">
                <div>
                  <fg-input
                    label="อีเมล"
                    type="email"
                    placeholder="Enter email"
                  >
                  </fg-input>
                  <fg-input
                    label="รหัสผ่าน"
                    type="password"
                    placeholder="Password"
                  >
                  </fg-input>
                  <div class="text-center">
                    <n-button
                      native-type="submit"
                      type="primary"
                      size="lg"
                      style="max-width: 257px; width: 100%"
                      >เข้าสู่ระบบ</n-button
                    >
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Form } from "vee-validate";
import { VeeInput } from "@/components";
const queryString = require("query-string");
const queryStrings = require("querystring");
import VueJwtDecode from "vue-jwt-decode";
import firebase from "firebase";
import Swal from "sweetalert2";
import VueElementLoading from "vue-element-loading";
import * as configuration from "../../middleware/configuration";
import * as userservice from "../../services/user";
import { message, Modal } from "ant-design-vue";

export default {
  components: {
    VeeInput,
    Form,
    VueElementLoading,
  },
  methods: {
    onClickShowLogin() {
      this.showLogin = ~this.showLogin;
    },
    onLogin(values) {
      this.showLoading();

      let email = values.target[0].value;
      let password = values.target[1].value;
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(
          (user) => {
            if (user) {
              if (localStorage.getItem("AcceptTerm")) {
                this.$router.push("/payment");
              } else {
                this.$router.push("/game");
              }
            }
          },
          (err) => {
            const swalWithBootstrapButtons = Swal.mixin({
              customClass: {
                confirmButton: "btn btn-info",
              },
              buttonsStyling: false,
            });

            swalWithBootstrapButtons.fire({
              title: `อีเมลหรือรหัสผ่านไม่ถูกต้อง`,
            });
          }
        )
        .finally(() => {
          this.hideLoading();
        });
    },
    async onSubmit(values) {
      var data = {
        Uid: values.Uid,
        Username: values.Username,
        Providers: values.Providers,
        Name: values.Name,
        Surname: values.Surname,
        Tel: values.PhoneNumber,
        Email: values.Email,
      };

      try {
        let res = await userservice.register(data);
        const datares = JSON.stringify(res.data);
        localStorage.setItem("userinfo", datares);
      } catch (error) {
        console.log(error);
        message.error("ไม่สามารถสมัครสาชิกได้ กรุณาลองอีกครั้ง");
      } finally {
        this.hideLoading();
        if (localStorage.getItem("AcceptTerm")) {
          this.$router.push("/payment");
        } else {
          this.$router.push("/game");
        }
      }
    },
    loginWithGoogle(e) {
      this.logingin = true;
      var provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().signInWithRedirect(provider);
    },
    loginWithFacebook(e) {
      this.logingin = true;
      var provider = new firebase.auth.FacebookAuthProvider();
      firebase.auth().signInWithRedirect(provider);
    },
    loginWithLine() {
      this.logingin = true;
      window.location.href =
        "https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1656018206&redirect_uri=http%3A%2F%2Frichmanshop.com%2Flogin&state=12345abcde&scope=profile%20openid%20email&nonce=09876xyz";
    },
    getLineRedirectResult(query) {
      let config = {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      };
      let data = queryStrings.stringify({
        grant_type: "authorization_code",
        code: query.code,
        redirect_uri: window.location.origin + window.location.pathname,
        client_id: "1656018206",
        client_secret: "57b99202b0230229d8f06d5f8460679c",
      });
      this.axios
        .post("https://api.line.me/oauth2/v2.1/token", data, config)
        .then((response) => {
          let jwt = VueJwtDecode.decode(response.data.id_token);

          var data = {
            access_token: response.data.access_token,
            email: jwt.email,
            name: jwt.name,
            picture: jwt.picture,
            id: jwt.sub,
          };

          var createCustomToken = firebase
            .app()
            .functions()
            .httpsCallable("createCustomToken");
          var defaultAuth = firebase.auth();

          createCustomToken(data).then((res) => {
            if (!res.data.error_message) {
              defaultAuth
                .signInWithCustomToken(res.data.firebase_token)
                .then(async (user) => {
                  var req = {
                    Uid: user.user.uid,
                    Username: null,
                    Providers: "line",
                    Name: user.user.displayName,
                    Surname: "",
                    PhoneNumber: user.user.phoneNumber,
                    Email: user.user.email,
                  };
                  await this.onSubmit(req);
                })
                .catch((error) => {
                  this.hideLoading();
                  console.log(error.message);
                });
            } else {
              this.hideLoading();
              Modal.error({
                title: "เข้าสู่ระบบไม่สำเร็จ",
                content: res.data.error_message.indexOf('The email address is already in use by another account') > -1 ? 'อีเมลถูกใช้ไปกับบัญชีอื่นแล้ว เช่น Google หรือ Facebook กรุณาลองอีกครั้ง' : res.data.error_message,
              });
              this.$router.push({path: "/login"});
            }
          });
        }).catch(err => {
          this.hideLoading();
          console.log(err)
        });
    },
    showLoading() {
      this.onLoading = true;
    },
    hideLoading() {
      this.onLoading = false;
    },
  },
  data() {
    return {
      onLoading: false,
      logingin: false,
    };
  },
  async beforeMount() {
    this.showLoading();

    var query = queryString.parse(window.location.search);
    if (Object.keys(query).length > 0) {
      this.getLineRedirectResult(query);
    } else {
      firebase
        .auth()
        .getRedirectResult()
        .then(async (user) => {
          if (user.credential) {
            var data = {
              Uid: user.user.uid,
              Username: null,
              Providers: user.additionalUserInfo.providerId,
              Name: user.additionalUserInfo.profile.given_name,
              Surname: user.additionalUserInfo.profile.family_name,
              PhoneNumber: user.user.phoneNumber,
              Email: user.user.email,
            };
            await this.onSubmit(data);
          }
        })
        .finally(() => {
          this.hideLoading();
        });

      let currentUser = await configuration.getCurrentUser();
      if (currentUser) {
        this.$router.push("/game");
      }
    }
  },
};
</script>

<style>
.separator {
  display: flex;
  align-items: center;
  text-align: center;
}

.separator::before,
.separator::after {
  content: "";
  flex: 1;
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.separator:not(:empty)::before {
  margin-right: 1em;
}

.separator:not(:empty)::after {
  margin-left: 1em;
}
</style>